import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../../assets/css/user/blogs/blogdetailpage.css";
import { Container, Spinner } from "react-bootstrap";
import Navbar from "../navbar/Navbar";
import SimpleBanner from "../general/SimpleBanner";
import Footer from "../footer/Footer";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import MarqueeBanner from "../Marqueebanner/Marqueebanner";

/* ── ICONS ── */
const ArrowLeft = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19 12H5M12 19l-7-7 7-7" />
  </svg>
);

const UserIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const CalendarIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const ShareIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

const LinkIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

/* ── BLOG DATA ── */
const blogData = {
  1: {
    id: 1,
    category: "Industry",
    categoryClass: "cat-industry",
    categoryBadge: "cat-industry-badge",
    categoryTxt: "cat-industry-txt",
    title: "How Instant Deals Are Changing the Service Industry",
    lead: "Discover how limited-time deals are revolutionizing how we book services and creating new opportunities for both providers and customers.",
    author: "Admin",
    initials: "AD",
    date: "Mar 28, 2026",
    readTime: "5",
    views: "2.4k",
    image:
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1200&q=85&auto=format&fit=crop",
    tags: ["Service Industry", "Instant Deals", "Time4Pulse", "Marketplace"],
    related: [
      "Why Sellers Love Time4Pulse Marketplace",
      "Top 10 Beauty Deals You Shouldn't Miss This Month",
      "5 Ways to Maximize Your Service Bookings",
    ],
    body: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
      "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet consectetur.",
    ],
    quote:
      "The service industry is being reshaped by real-time demand — and Time4Pulse is at the forefront of that transformation.",
  },
  2: {
    id: 2,
    category: "Beauty",
    categoryClass: "cat-beauty",
    categoryBadge: "cat-beauty-badge",
    categoryTxt: "cat-beauty-txt",
    title: "Top 10 Beauty Deals You Shouldn't Miss This Month",
    lead: "From facials to full makeovers, these deals offer incredible value for every beauty enthusiast looking to treat themselves.",
    author: "Admin",
    initials: "AD",
    date: "Mar 25, 2026",
    readTime: "4",
    views: "3.1k",
    image:
      "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1200&q=85&auto=format&fit=crop",
    tags: ["Beauty", "Deals", "Skincare", "Wellness", "Self-Care"],
    related: [
      "How Instant Deals Are Changing the Service Industry",
      "Why Sellers Love Time4Pulse Marketplace",
      "Best Skincare Routines for Busy Professionals",
    ],
    body: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
      "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet consectetur.",
    ],
    quote:
      "Great skincare doesn't have to break the bank — these curated beauty deals bring luxury within reach for everyone.",
  },
  3: {
    id: 3,
    category: "Business",
    categoryClass: "cat-business",
    categoryBadge: "cat-business-badge",
    categoryTxt: "cat-business-txt",
    title: "Why Sellers Love Time4Pulse Marketplace",
    lead: "Learn how service providers are filling empty slots and boosting revenue with smart deal management tools on the Time4Pulse platform.",
    author: "Admin",
    initials: "AD",
    date: "Mar 20, 2026",
    readTime: "6",
    views: "1.8k",
    image:
      "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=85&auto=format&fit=crop",
    tags: ["Business", "Sellers", "Revenue", "Marketplace", "Growth"],
    related: [
      "How Instant Deals Are Changing the Service Industry",
      "Top 10 Beauty Deals You Shouldn't Miss This Month",
      "Growing Your Service Business in 2026",
    ],
    body: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
      "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet consectetur.",
    ],
    quote:
      "Time4Pulse gives sellers the tools to turn downtime into revenue — making empty calendar slots a thing of the past.",
  },
};

/* ── COMPONENT ── */
const BlogsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [blogDetail, setBlogDetail] = useState(null);
  const [oldImage, setOldImage] = useState("");
  const [loading, setLoading] = useState(false);
  const articleRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [copied, setCopied] = useState(false);

  const post = blogDetail;
  const fetchBlogDetail = () => {
    setLoading(true);

    axios
      .get(`${baseUrl}/customer/blog/fetchSingleBlog/${id}`)
      .then((res) => {
        console.log("Blog Detail:", res.data);

        if (res.data.success === true) {
          setBlogDetail(res.data.blog);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // Reading progress bar
  useEffect(() => {
    const handleScroll = () => {
      const el = articleRef.current;
      if (!el) return;
      const { top, height } = el.getBoundingClientRect();
      const winH = window.innerHeight;
      const total = height - winH;
      const scrolled = Math.min(Math.max(-top, 0), total);
      setScrollProgress(total > 0 ? (scrolled / total) * 100 : 0);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll to top on mount
  useEffect(() => {
    fetchBlogDetail();
    window.scrollTo(0, 0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (!post) {
    return <Container className="text-center py-5">Blog not found</Container>;
  }

  return (
    <>
      <MarqueeBanner />
      <Navbar />
      <SimpleBanner
        title="Blog"
        subtitle=""
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "blog", href: "/blog" },
          { label: "Blog Detail", href: `/blog/detail/${post.id}` },
        ]}
      />
      <Container fluid>
        <div className="bd-page" ref={articleRef}>
          {/* Progress Bar */}
          <div
            className="bd-progress-bar"
            style={{ width: `${scrollProgress}%` }}
          />

          {/* Top Nav */}
          <nav className="bd-topbar">
            <button className="blog-view-all" onClick={() => navigate("/blog")}>
              <ArrowLeft /> Back to Blogs
            </button>
          </nav>

          {/* Hero */}
          <header className="bd-hero">
            <span className="bd-category-badge">{post.category || "Blog"}</span>

            <h1 className="bd-title">{post.title}</h1>

            <div className="bd-meta">
              <div className="bd-meta-item">
                <UserIcon />
                <span>Admin</span>
              </div>
              <span className="bd-meta-divider" />
              <div className="bd-meta-item">
                <CalendarIcon />
                <span>
                  {new Date(post.created_at).toLocaleDateString("en-GB")}
                </span>
              </div>
            </div>
          </header>

          {/* Featured Image */}
          <div className="bd-image-wrap">
            <div className="bd-image-inner">
              <img src={`${baseUrlForFiles}/${post.image}`} alt={post.title} />
              <div className="bd-image-overlay" />
            </div>
          </div>

          {/* Content + Sidebar */}
          <div className="bd-content-wrap">
            {/* Article */}
            <article className="bd-article">
              <div
                className="bd-body"
                dangerouslySetInnerHTML={{ __html: post.description }}
              />

              <div className="bd-tags">
                <span className="bd-tag">{post.category || "Blog"}</span>
              </div>
            </article>

            {/* Sidebar */}
            <aside className="bd-sidebar">
              {/* Author */}
              <div className="bd-sidebar-card">
                <p className="bd-sidebar-card-title">Author</p>
                <div className="bd-author-wrap">
                  <div className="bd-author-avatar">AD</div>
                  <div>
                    <span className="bd-author-name">Admin</span>
                    <span className="bd-author-role">
                      Content Writer · Time4Pulse
                    </span>
                  </div>
                </div>
              </div>

              {/* Stats */}
              <div className="bd-sidebar-card">
                <p className="bd-sidebar-card-title">Article Stats</p>
                <div className="bd-stats-grid">
                  <div className="bd-stat">
                    <span className="bd-stat-value">--</span>

                    <span className="bd-stat-value">--</span>
                  </div>
                </div>
              </div>

              {/* Related Posts */}
              <div className="bd-sidebar-card">
                <p className="bd-sidebar-card-title">Related Posts</p>

                <p>No Related Posts</p>
              </div>

              {/* Share */}
              <div className="bd-sidebar-card">
                <p className="bd-sidebar-card-title">Share Article</p>
                <div className="bd-share-row">
                  <button className="bd-share-btn">
                    <ShareIcon /> Share
                  </button>
                  <button className="bd-share-btn" onClick={handleCopyLink}>
                    <LinkIcon /> {copied ? "Copied!" : "Copy"}
                  </button>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default BlogsDetail;
